import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { c as f } from "./index-DkZ16bcJ.mjs";
import { b as x, a as m } from "./enums-BtUzbEmn.mjs";
import { c as g } from "./capitalize-iyaz5rT3.mjs";
import { f as c } from "./index-LyFokDcn.mjs";
import { m as u } from "./tss-DN0acMKN.mjs";
import { M as w, d as p } from "./constants-CnFYFetN.mjs";
function S(o = "fab-Card", e = m.MEDIUM) {
  return `${o}--size${g(e)}`;
}
function v(o, { flex: e, hasBottomGradient: a, size: r } = {}) {
  return f(o, S(o, r), {
    [`${o}--flexColumn`]: e === x.COLUMN,
    [`${o}--flexRow`]: e === x.ROW,
    [`${o}--withoutBottomGradient`]: !a
  });
}
function G(o) {
  return Object.values(m).includes(o);
}
const n = {
  small: "608px",
  medium: "800px",
  full: "100%"
}, y = u()((o, e) => {
  const { constructs: a, palette: r, mixins: t } = o, { flex: d, hasHover: i, size: l } = e;
  return {
    root: {
      boxSizing: "border-box",
      backgroundColor: r.common.white,
      border: `1px solid ${r.gray[200]}`,
      borderRadius: "16px",
      boxShadow: `1px 1px 0px 2px ${t.alpha(a.surface.neutral.xxStrong, 0.03)}`,
      overflow: "auto",
      position: "relative",
      textAlign: "left",
      flexDirection: d || void 0,
      transition: "box-shadow 0.2s ease-in-out",
      width: n[l],
      "&:hover": i ? {
        boxShadow: `3px 3px 10px 2px ${t.alpha(a.surface.neutral.xxStrong, 0.1)}`
      } : {}
    }
  };
}), z = u()((o) => {
  const { palette: e, mixins: a, mode: r } = o;
  return {
    root: {
      boxSizing: "border-box",
      backgroundColor: e.common.white,
      border: `1px solid ${e.grey[200]}`,
      borderRadius: "16px",
      boxShadow: `1px 1px 0px 2px ${a.alpha(e.gray[900], 0.03)}`,
      overflow: "hidden",
      position: "relative",
      textAlign: "left",
      padding: "20px",
      outline: r === w.Dye ? `1px solid ${p.main}` : void 0
    },
    ".fab-Card--flexColumn": {
      display: "flex",
      flexDirection: "column"
    },
    ".fab-Card--flexRow": {
      display: "flex",
      flexDirection: "row"
    },
    ".fab-Card--sizeSmall": {
      width: n.small
    },
    ".fab-Card--sizeMedium": {
      width: n.medium
    },
    ".fab-Card--sizeFull": {
      width: n.full
    },
    ".fab-Card--noPadding": {
      padding: 0
    },
    ".fab-Card--hasHover": {
      transition: "box-shadow 0.2s ease-in-out",
      "&:hover": {
        boxShadow: `3px 3px 10px 2px ${a.alpha(e.gray[900], 0.1)}`
      }
    },
    ".fab-Card__bottomGradient": {
      background: p.main
    }
  };
}), $ = (o) => {
  const { children: e, encoreOnly: a, hasBottomGradient: r = !0, flex: t, hasHover: d = !1, size: i } = o, { classes: l } = y(
    { flex: t, hasHover: d, size: i },
    c.ifFeature("encore", { props: { classes: o.classes } })
  ), { classes: b } = z(), C = /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: f(
        b.root,
        v("fab-Card", { flex: t, hasBottomGradient: r, size: i })
      ),
      children: [
        e,
        r && /* @__PURE__ */ s.jsx("div", { className: "fab-Card__bottomGradient" })
      ]
    }
  ), h = /* @__PURE__ */ s.jsx("div", { className: l.root, "data-fabric-component": "Card", children: e });
  return c.ifFeature("encore", h, a ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : C);
};
$.displayName = "Card";
export {
  $ as C,
  n as c,
  G as h
};
//# sourceMappingURL=card-vPwejA0-.mjs.map
